import { useState } from "react";
import { getEmployerLogo, getEmployerLogoFallback, getEmployerInitials } from "../lib/employerLogo";

/** Renders a TOC/employer logo with graceful fallbacks:
 *  override URL → Apistemic logo → Google favicon → coloured-initials avatar.
 */
export default function EmployerLogo({ name, override, size = 36, className = "" }) {
  const [stage, setStage] = useState(0); // 0=primary, 1=fallback, 2=initials
  const initials = getEmployerInitials(name);
  const px = `${size}px`;

  let src = null;
  if (stage === 0) src = getEmployerLogo(name, override);
  else if (stage === 1) src = getEmployerLogoFallback(name);

  if (!src || stage >= 2) {
    return (
      <div
        className={`flex items-center justify-center rounded-md bg-sky/12 border border-sky/30 text-sky font-display font-bold ${className}`}
        style={{ width: px, height: px, fontSize: Math.round(size * 0.36), lineHeight: 1 }}
        aria-label={name}
      >
        {initials}
      </div>
    );
  }
  return (
    <div
      className={`flex items-center justify-center rounded-md bg-paper border border-line overflow-hidden ${className}`}
      style={{ width: px, height: px }}
    >
      <img
        src={src}
        alt={name + " logo"}
        loading="lazy"
        referrerPolicy="no-referrer"
        onError={() => setStage((s) => s + 1)}
        className="w-full h-full object-contain p-1"
      />
    </div>
  );
}
